import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, CircularProgress, FormHelperText } from '@material-ui/core'

import { MyTable } from './MyTable'

import { ITableData } from '../types/tableTypes'
import { YmAccountProps } from '../types/accountProps'
import { YandexMarketPrintOrderColumnId, createYmPrintOrderColumns } from '../types/yandexMarketColumns'

import { YandexMarketPrintOrderModel } from '../server/mpsklad_core/Models/YandexMarketPrintOrderModel'

export type YandexMarketPreviewPrintTableProps =
  YmAccountProps & {
  orders: ITableData<YandexMarketPrintOrderModel, YandexMarketPrintOrderColumnId>
}

export const YandexMarketPreviewPrintTable =
  observer(
    ({account, orders}: YandexMarketPreviewPrintTableProps) => {
      if (orders === null) {
        return (
          <Box padding={2}>
            <CircularProgress size={20}/>
          </Box>
        )
      }

      return <>
        <FormHelperText>
          Выбрано заказов: {orders.selectedRowCount}
        </FormHelperText>

        <MyTable
          table={orders}
          columns={createYmPrintOrderColumns(account)}
          labelNoRows="Заказов нет"
          labelNotFound="Заказы не найдены"
          labelRowsPerPage="Заказов на странице:"
        />
      </>
    })